import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sbp.png'


const _withScopeId = n => (_pushScopeId("data-v-e7622ace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md qr-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h4 text-center q-mb-md" }, "ОПЛАТА ПО QR-КОДУ", -1))
const _hoisted_3 = { class: "text-h5 text-center q-pt-md" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "text-h5 text-center" }
const _hoisted_6 = { class: "text-h5 text-center" }
const _hoisted_7 = { class: "text-h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_container = _resolveComponent("q-container")!

  return (_openBlock(), _createBlock(_component_q_container, { class: "row" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePayments, (payment) => {
          return (_openBlock(), _createBlock(_component_q_card, {
            class: "my-card q-mb-md",
            key: payment.id_pay_set
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(" Отсканируйте QR-код"),
                _hoisted_4,
                _createTextVNode(" при помощи телефона "),
                _createVNode(_component_q_icon, {
                  name: "center_focus_strong",
                  size: "35px"
                })
              ]),
              _createVNode(_component_q_img, {
                src: `https://host2.medsafe.tech/${payment.hash}`,
                class: "current-qr"
              }, null, 8, ["src"]),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(" Сумма: "),
                    _createElementVNode("b", null, [
                      _createTextVNode(_toDisplayString(payment.sum_pay) + " ", 1),
                      _createVNode(_component_q_icon, { name: "currency_ruble" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode("ФИО: "),
                    _createElementVNode("b", null, _toDisplayString(payment.fio), 1)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_card_section, { class: "q-pt-none text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode("Стастус: "),
                    _createElementVNode("b", null, _toDisplayString(payment.pay_status_text), 1)
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_q_img, {
          src: _imports_0,
          class: "sbp-logo q-mx-auto",
          ratio: 1,
          style: {"height":"140px","margin":"0 auto"},
          fit: "contain"
        })
      ])
    ]),
    _: 1
  }))
}